"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.webVitals = webVitals;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _webVitals2 = require("web-vitals");

var KEY = "ga:user";
var UID = localStorage[KEY] = localStorage[KEY] || Math.random() + "." + Math.random();

function onError(err) {
  console.error("[gatsby-plugin-web-vitals]", err); // eslint-disable-line no-console
}

function onDebug(label, payload) {
  console.log(label, payload); // eslint-disable-line no-console
}

function encode(obj) {
  var k;
  var str = "https://www.google-analytics.com/collect?v=1";

  for (k in obj) {
    if (obj[k]) {
      str += "&" + k + "=" + encodeURIComponent(obj[k]);
    }
  }

  return str;
}

function sendToAnalytics(metric, options) {
  var name = metric.name,
      delta = metric.delta,
      id = metric.id,
      entries = metric.entries;

  if (!options.metrics.includes(name)) {
    return;
  }

  var opts = {
    ec: options.eventCategory,
    ea: name,
    el: id,
    // Google Analytics metrics must be integers, so the value is rounded.
    ev: parseInt(delta),
    dl: location.href,
    dp: location.pathname,
    ni: true
  }; // Calculate the request time by subtracting from TTFB
  // everything that happened prior to the request starting.

  if (name === "TTFB") {
    opts.ev = parseInt(delta - entries[0].requestStart);
  }

  var args = (0, _extends2.default)({
    tid: options.trackingId,
    cid: UID
  }, opts);
  var obj = (0, _extends2.default)((0, _extends2.default)((0, _extends2.default)({
    t: "event"
  }, args), opts), {}, {
    z: Date.now()
  });
  var url = encode(obj);

  if (options.debug) {
    onDebug(name, JSON.stringify(obj, null, 2));
    onDebug(name + " URL", url);
  }

  if (navigator.sendBeacon) {
    navigator.sendBeacon(url, null);
  } else {
    fetch(url, {
      method: "POST",
      keepalive: true
    }).catch(onError);
  }
}

function webVitals(_x) {
  return _webVitals.apply(this, arguments);
}

function _webVitals() {
  _webVitals = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref) {
    var options;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _ref.options;

            try {
              (0, _webVitals2.getFID)(function (metric) {
                return sendToAnalytics(metric, options);
              });
              (0, _webVitals2.getTTFB)(function (metric) {
                return sendToAnalytics(metric, options);
              });
              (0, _webVitals2.getLCP)(function (metric) {
                return sendToAnalytics(metric, options);
              });
              (0, _webVitals2.getCLS)(function (metric) {
                return sendToAnalytics(metric, options);
              });
              (0, _webVitals2.getFCP)(function (metric) {
                return sendToAnalytics(metric, options);
              });
            } catch (err) {
              onError(err);
            }

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _webVitals.apply(this, arguments);
}